import { connect } from "react-redux";

import { requestDailyStatistics, filterDataCompressorsLastLeerlauf } from "../model/util/DailyValues";
import LastLeerlaufTabelle from "./LastLeerlaufTabelle";

export default connect(state => ({
	model: filterDataCompressorsLastLeerlauf(state.charts.daily_values.last_leerlauf, state.ablauf.compressors),
	timespan: state.charts.daily_values.timespan,
	rtc: state.rtc,
	compressors: state.ablauf.compressors,
	units: state.units
}), dispatch => ({
	refresh: timespan => {
		requestDailyStatistics("last_leerlauf",
			timespan.from_ms, timespan.until_ms, dispatch);
	}
}))(LastLeerlaufTabelle);
